// Story Publish Statuses
export const STORY_PUBLISH_STATUS_ACTIVE = "active";
export const STORY_PUBLISH_STATUS_DRAFT = "draft";
export const STORY_PUBLISH_STATUS_SCHEDULED = "scheduled";
export const STORY_PUBLISH_STATUS_SCHEDULED_NEEDS_REVIEW = "scheduled_needs_review";
export const STORY_PUBLISH_STATUS_SUBMITTED_FOR_REVIEW = "submitted_for_review";
export const STORY_PUBLISH_STATUS_NEEDS_EDITING = "needs_editing";
export const STORY_PUBLISH_STATUS_PUBLISH_FAILED = "publish_failed";

// Story Statuses Label
export const STORY_STATUS_LABEL_ACTIVE = "Published & Live";
export const STORY_STATUS_LABEL_DRAFT = "Draft";
export const STORY_STATUS_LABEL_SCHEDULED = "Scheduled To Go Live";
export const STORY_STATUS_LABEL_SCHEDULED_NEEDS_REVIEW = "Scheduled But Needs Review";
export const STORY_STATUS_LABEL_SUBMITTED_FOR_REVIEW = "Pending Approval";
export const STORY_STATUS_LABEL_NEEDS_EDITING = "Needs Editing";
export const STORY_STATUS_LABEL_PUBLISH_FAILED = "Publishing Failed";
